// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Alert__buttons___1wqUa"};